export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
            了解91吃瓜，加入最活跃的吃瓜群众社区
          </p>
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                91吃瓜成立于2024年，是全网最具影响力的吃瓜群众聚集地之一。我们致力于为广大网友提供一个
                真实、开放、有趣的互动交流平台，让每一位吃瓜群众都能在这里找到归属感。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台涵盖了娱乐八卦、社会热点、科技财经、体育电竞、网红直播等多个热门领域，
                每日更新海量真实爆料与深度讨论内容。我们拥有严格的信源核实机制，力求在第一时间
                为吃瓜群众呈现最接近真相的资讯。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                目前，91吃瓜社区已汇聚超过200万活跃用户，日均话题讨论量突破50万条。
                无论你是想追踪最新八卦、参与热门讨论，还是分享独家爆料，
                这里都有最热闹的氛围和最热情的吃瓜群众在等你。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                我们的使命：让每一次吃瓜都成为一次愉快的社交体验。
                欢迎加入91吃瓜群众大家庭，一起畅快吃瓜、快乐互动！
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500 font-heading">200万+</div>
                <div className="text-xs text-foreground-500 mt-1">注册用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-500 font-heading">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-500 font-heading">1000万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计话题</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500 font-heading">8个</div>
                <div className="text-xs text-foreground-500 mt-1">内容频道</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}